chRecaptchaOnLoad = function () {
    window.chRecaptcha.onLoad();
}
chRecaptchaOnSubmit = function () {
    window.chRecaptcha.onSubmit();
}

window.chRecaptcha = {
    options: {
        submitButton: undefined,
        consentName: 'RecaptchaConsent'
    },
    initialised: false,
    shouldSubmit: false,
    init: function (options) {
        //load options - first
        this.options = $.extend({}, this.options, options);

        if (this.options.submitButton.length === 0) {
            throw new Error('Could not find submit button');
        }

        var consentField = $('[name="' + this.options.consentName + '"]');
        consentField.prop('checked', false);

        this.toggleSubmitButton(false);

        var _self = this;
        consentField.on('change', function (event) {
            if (!_self.initialised) {
                _self.initialised = true;

                //handle webforms onclick handlers, store the onclick handler and call it later
                _self.onClickAttr = _self.options.submitButton.get(0).onclick;
                if (_self.onClickAttr) {
                    //clear onclick handler
                    _self.options.submitButton.attr('onclick', null);
                }
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://www.google.com/recaptcha/api.js?onload=chRecaptchaOnLoad';
                script.async = true;
                script.defer = true;
                document.body.appendChild(script);
            } else {
                _self.toggleSubmitButton(event.target.checked);
            }
        });

    },
    onSubmit: function () {
        var form = this.options.submitButton.closest('form');
        if (form.get(0).reportValidity && !form.get(0).reportValidity()) {
            return;
        }
        if (this.onClickAttr) {
            this.onClickAttr();
            return;
        }
        this.toggleSubmitButton(true);
        form.submit();
    },
    onLoad: function () {
        // prevent it messing up vintage button layouts, move to the end of the parent
        $('.grecaptcha-badge').parent().appendTo($('.grecaptcha-badge').parent().parent());
        this.toggleSubmitButton(true);
    },
    toggleSubmitButton: function (enabled) {
        this.options.submitButton.attr('disabled', !enabled);
        if (enabled) {
            this.options.submitButton.removeClass('disabled')
        } else {
            this.options.submitButton.addClass('disabled');
        }
    }
}
